import React, { memo, useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { Menu, MenuItem, MenuButton } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import { FaUser } from "react-icons/fa";
import { MdPrivacyTip } from "react-icons/md";
import { LuLogOut } from "react-icons/lu";
import { RiLockPasswordLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";

import {
  useGetNotifaction,
  useReadNotifaction,
} from "../api/useProducts/useNotifaction";
import moment from "moment";
import { useResetPassword } from "../api/useProducts/useUser";
import CustomButton from "./CustomButton";
const Header: React.FC = () => {
  // const { mutate: ReactNotifaction } = useReadNotifaction();
  // const { notifactionData, notifactionLoading, notifactionRefetch } =
  //   useGetNotifaction({ page: 0, limit: 0 });
  const { mutate: ResetPass,isPending } = useResetPassword();
  const navigate = useNavigate();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const openModal = () => setShowPasswordModal(true);
  const closeModal = () => {
    setShowPasswordModal(false);
    reset(); // clear form when modal closes
  };

  const handleLogOut = () => {
    sessionStorage.removeItem("access-token");
    navigate("/auth/login");
  };
  const storedUserDetail = sessionStorage.getItem("UserDetail");
  const User = storedUserDetail ? JSON.parse(storedUserDetail) : null;
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm();
  const newPassword = watch("newPassword");
  // useEffect(() => {
  //   notifactionRefetch();
  // }, []);
  // const handleReadNotifaction = () => {
  //   ReactNotifaction({});
  //   notifactionRefetch();
  // };

  const onSubmit = (data: any) => {
    ResetPass(
      {
        password: data.confirmPassword,
      },
      {
        onSuccess: async (data: any) => {
          toast.success("Password successfully Changed");
          closeModal();
        },
        onError: (error: any) => {
          toast.error("something went wrong");
          closeModal();
        },
      }
    );
  };

  return (
    <div className="flex px-4 gap-6 justify-between flex-wrap items-center border-b-[1.5px]  pb-3">
      {/* <div className="bg-white flex gap-2  px-2 rounded-lg flex-1 items-center border">
        <input
          type="text"
          placeholder="Search here"
          className="border-0 focus:border-0 focus-visible:outline-none p-2.5 flex-1 caret-darkCyan"
        />
        <CiSearch size={28} className="text-gray-400" />
      </div> */}
      {/* <div className="relative ">
        <span className="absolute top-[-5px] end-0 bg-darkCyan min-w-5 rounded-full min-h-5  text-white text-xs flex justify-center items-center">
          22
        </span>
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="48"
            height="48"
            rx="15"
            fill="#24B1B3"
            fill-opacity="0.15"
          />
          <path
            d="M14.6667 33.3333H21.6667C21.6667 33.9522 21.9125 34.5457 22.3501 34.9833C22.7877 35.4208 23.3812 35.6667 24 35.6667C24.6188 35.6667 25.2123 35.4208 25.6499 34.9833C26.0875 34.5457 26.3333 33.9522 26.3333 33.3333H33.3333C33.6428 33.3333 33.9395 33.2104 34.1583 32.9916C34.3771 32.7728 34.5 32.4761 34.5 32.1667C34.5 31.8572 34.3771 31.5605 34.1583 31.3417C33.9395 31.1229 33.6428 31 33.3333 31V22.8333C33.3333 20.358 32.35 17.984 30.5997 16.2337C28.8493 14.4833 26.4754 13.5 24 13.5C21.5246 13.5 19.1507 14.4833 17.4003 16.2337C15.65 17.984 14.6667 20.358 14.6667 22.8333V31C14.3572 31 14.0605 31.1229 13.8417 31.3417C13.6229 31.5605 13.5 31.8572 13.5 32.1667C13.5 32.4761 13.6229 32.7728 13.8417 32.9916C14.0605 33.2104 14.3572 33.3333 14.6667 33.3333V33.3333ZM17 22.8333C17 20.9768 17.7375 19.1963 19.0503 17.8836C20.363 16.5708 22.1435 15.8333 24 15.8333C25.8565 15.8333 27.637 16.5708 28.9497 17.8836C30.2625 19.1963 31 20.9768 31 22.8333V31H17V22.8333Z"
            fill="#24B1B3"
          />
        </svg>
      </div> */}
      <div className="flex gap-2 items-center">
        <img
          src={User?.profile || "/images/profile.jpg"}
          alt="image not found"
          className="w-14 h-14 rounded-full border-2 border-white object-cover"
        />
        <p className="mb-0">{User?.name || "Anonymous"}</p>
      </div>
      <div className="flex gap-2">
        {/* <div className="relative">
          <Menu
            menuButton={
              <MenuButton>
                <div className="relative " onClick={handleReadNotifaction}>
                  <span className="absolute top-[-5px] end-0 bg-darkCyan min-w-5 rounded-full min-h-5  text-white text-xs flex justify-center items-center">
                    {notifactionData?.data?.length || "0"}
                  </span>
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="48"
                      height="48"
                      rx="15"
                      fill="#24B1B3"
                      fill-opacity="0.15"
                    />
                    <path
                      d="M14.6667 33.3333H21.6667C21.6667 33.9522 21.9125 34.5457 22.3501 34.9833C22.7877 35.4208 23.3812 35.6667 24 35.6667C24.6188 35.6667 25.2123 35.4208 25.6499 34.9833C26.0875 34.5457 26.3333 33.9522 26.3333 33.3333H33.3333C33.6428 33.3333 33.9395 33.2104 34.1583 32.9916C34.3771 32.7728 34.5 32.4761 34.5 32.1667C34.5 31.8572 34.3771 31.5605 34.1583 31.3417C33.9395 31.1229 33.6428 31 33.3333 31V22.8333C33.3333 20.358 32.35 17.984 30.5997 16.2337C28.8493 14.4833 26.4754 13.5 24 13.5C21.5246 13.5 19.1507 14.4833 17.4003 16.2337C15.65 17.984 14.6667 20.358 14.6667 22.8333V31C14.3572 31 14.0605 31.1229 13.8417 31.3417C13.6229 31.5605 13.5 31.8572 13.5 32.1667C13.5 32.4761 13.6229 32.7728 13.8417 32.9916C14.0605 33.2104 14.3572 33.3333 14.6667 33.3333V33.3333ZM17 22.8333C17 20.9768 17.7375 19.1963 19.0503 17.8836C20.363 16.5708 22.1435 15.8333 24 15.8333C25.8565 15.8333 27.637 16.5708 28.9497 17.8836C30.2625 19.1963 31 20.9768 31 22.8333V31H17V22.8333Z"
                      fill="#24B1B3"
                    />
                  </svg>
                </div>
              </MenuButton>
            }
            transition
            direction={"bottom"}
            align={"end"}
            position={"anchor"}
            viewScroll={"auto"}
            arrow={true}
            gap={5}
            shift={5}
            className="shadow-lg "
          >
            <div className="bg-darkCyan  text-white font-semibold p-2 flex items-center justify-between">
              <span>Notifications</span>
            </div>
            <div className="bg-white max-h-60 overflow-y-auto">
              {notifactionData?.data.map((notification, idx) => (
                <MenuItem key={idx} className="p-2 hover:bg-gray-100">
                 
                  <div className="">
                    <p className="text-sm font-semibold text-gray-700">
                      {notification?.heading.slice(0, 12)}{" "}
                     
                    </p>
                    <p className="text-xs text-gray-400">
                      {moment(notification?.createdAt).fromNow()}
                    </p>
                  </div>
                  <span className="text-blue-400 text-xs ml-2">•</span>
                </MenuItem>
              ))}
            </div>
            <div className="text-center p-2 border-t">
              <Link
                to="/notification"
                className="text-darkCyan text-sm font-medium"
              >
                See all recent activity
              </Link>
            </div>
          </Menu>
        </div> */}
        <Menu
          menuButton={
            <MenuButton>
              {" "}
              <div>
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_1_3737)">
                    <rect
                      x="4"
                      width="48"
                      height="48"
                      rx="15"
                      fill="#FF5B5B"
                      fill-opacity="0.15"
                    />
                    <path
                      d="M28.0001 19.625C27.1348 19.625 26.289 19.8816 25.5695 20.3623C24.85 20.8431 24.2893 21.5263 23.9582 22.3258C23.627 23.1252 23.5404 24.0048 23.7092 24.8535C23.878 25.7022 24.2947 26.4817 24.9065 27.0936C25.5184 27.7054 26.2979 28.1221 27.1466 28.2909C27.9953 28.4597 28.8749 28.3731 29.6744 28.042C30.4738 27.7108 31.1571 27.1501 31.6378 26.4306C32.1185 25.7111 32.3751 24.8653 32.3751 24C32.3737 22.8401 31.9124 21.7281 31.0922 20.9079C30.272 20.0877 29.16 19.6264 28.0001 19.625V19.625ZM28.0001 26.625C27.4809 26.625 26.9734 26.471 26.5417 26.1826C26.1101 25.8942 25.7736 25.4842 25.5749 25.0045C25.3763 24.5249 25.3243 23.9971 25.4256 23.4879C25.5268 22.9787 25.7769 22.511 26.144 22.1438C26.5111 21.7767 26.9788 21.5267 27.488 21.4254C27.9972 21.3241 28.525 21.3761 29.0047 21.5748C29.4843 21.7735 29.8943 22.1099 30.1827 22.5416C30.4712 22.9733 30.6251 23.4808 30.6251 24C30.6243 24.696 30.3475 25.3632 29.8554 25.8553C29.3633 26.3474 28.6961 26.6242 28.0001 26.625V26.625Z"
                      fill="#FF5B5B"
                    />
                    <path
                      d="M19.4893 18.5599C19.0591 18.3983 18.5828 18.4104 18.1613 18.5936C17.7397 18.7768 17.406 19.1168 17.2307 19.5417C17.0554 19.9665 17.0522 20.443 17.2219 20.8701C17.3915 21.2973 17.7207 21.6417 18.1397 21.8305C18.566 22.0108 18.9297 22.3128 19.1855 22.6986C19.4412 23.0844 19.5776 23.537 19.5776 23.9999C19.5776 24.4627 19.4412 24.9153 19.1855 25.3012C18.9297 25.687 18.566 25.9889 18.1397 26.1692C17.7206 26.358 17.3913 26.7025 17.2216 27.1298C17.052 27.557 17.0552 28.0335 17.2306 28.4585C17.406 28.8834 17.7399 29.2234 18.1615 29.4065C18.5832 29.5897 19.0595 29.6016 19.4898 29.4398C19.9192 29.2649 20.3906 29.2206 20.8451 29.3125C21.2995 29.4043 21.7167 29.6283 22.0445 29.9562C22.3722 30.2841 22.5959 30.7014 22.6875 31.1559C22.7792 31.6103 22.7347 32.0817 22.5596 32.511C22.3927 32.9424 22.4031 33.4223 22.5884 33.8461C22.7738 34.2699 23.1191 34.6033 23.5491 34.7737C23.7645 34.8628 23.9953 34.9087 24.2284 34.9087C24.5689 34.9111 24.9026 34.8129 25.1875 34.6265C25.4724 34.44 25.696 34.1736 25.8302 33.8606C26.0105 33.4343 26.3124 33.0706 26.6982 32.8149C27.084 32.5592 27.5366 32.4228 27.9995 32.4228C28.4624 32.4228 28.915 32.5592 29.3008 32.8149C29.6866 33.0706 29.9885 33.4343 30.1689 33.8606C30.3577 34.2798 30.7022 34.609 31.1294 34.7787C31.5567 34.9484 32.0332 34.9451 32.4581 34.7697C32.883 34.5943 33.223 34.2605 33.4062 33.8388C33.5893 33.4172 33.6013 32.9408 33.4394 32.5105C33.2646 32.0811 33.2203 31.6097 33.3121 31.1553C33.404 30.7009 33.6279 30.2836 33.9558 29.9559C34.2837 29.6281 34.701 29.4044 35.1555 29.3128C35.61 29.2212 36.0814 29.2657 36.5107 29.4407C36.9394 29.6072 37.4164 29.5983 37.8386 29.4159C38.2608 29.2335 38.5942 28.8924 38.767 28.4662L37.9646 28.1176L37.1683 27.8194C36.4205 27.5138 35.599 27.4362 34.8072 27.5963C34.0154 27.7564 33.2886 28.1471 32.7182 28.7191C32.1482 29.2937 31.7566 30.0209 31.5906 30.813C31.4245 31.6051 31.4912 32.4283 31.7824 33.1834C31.4703 32.4382 30.9446 31.802 30.2715 31.3552C29.5984 30.9083 28.808 30.6707 28.0001 30.6724C27.1904 30.6749 26.3988 30.912 25.721 31.3551C25.0433 31.7981 24.5085 32.4281 24.1813 33.1688C24.4866 32.4209 24.5641 31.5995 24.404 30.8077C24.244 30.0159 23.8534 29.2891 23.2816 28.7186C22.7069 28.1487 21.9798 27.7572 21.1877 27.5911C20.3956 27.4251 19.5724 27.4917 18.8173 27.7829C19.5625 27.4707 20.1986 26.9448 20.6453 26.2716C21.0921 25.5984 21.3296 24.808 21.3278 24.0001C21.3253 23.1904 21.0881 22.3988 20.6451 21.721C20.202 21.0433 19.5721 20.5085 18.8314 20.1813C19.5792 20.4868 20.4007 20.5644 21.1925 20.4043C21.9843 20.2442 22.7111 19.8536 23.2816 19.2816C23.8515 18.707 24.2431 17.9798 24.4092 17.1877C24.5752 16.3956 24.5086 15.5724 24.2173 14.8173C24.5295 15.5625 25.0554 16.1986 25.7285 16.6453C26.4017 17.0921 27.1921 17.3296 28.0001 17.3278C28.8098 17.3253 29.6014 17.0881 30.2791 16.6451C30.9569 16.202 31.4917 15.5721 31.8188 14.8314C31.5135 15.5793 31.436 16.4007 31.5961 17.1925C31.7562 17.9842 32.1467 18.711 32.7186 19.2816C33.2934 19.8512 34.0205 20.2426 34.8126 20.4087C35.6046 20.5747 36.4277 20.5082 37.1829 20.2173C36.4413 20.5288 35.8078 21.0518 35.3614 21.7209C34.9149 22.39 34.6753 23.1758 34.6724 23.9802C34.6695 24.7845 34.9034 25.572 35.345 26.2443C35.7865 26.9167 36.4162 27.4442 37.1556 27.7611C37.158 27.7683 37.158 27.7761 37.1556 27.7833L37.9643 28.117L38.7684 28.4618L38.7731 28.4507C38.9517 28.0269 38.9561 27.5499 38.7852 27.1229C38.6144 26.696 38.2821 26.3536 37.8605 26.1701C37.4342 25.9898 37.0704 25.6878 36.8147 25.302C36.559 24.9162 36.4226 24.4636 36.4226 24.0007C36.4226 23.5379 36.559 23.0853 36.8147 22.6994C37.0704 22.3136 37.4342 22.0117 37.8605 21.8314C38.2796 21.6426 38.6088 21.2981 38.7785 20.8708C38.9482 20.4436 38.945 19.9671 38.7696 19.5421C38.5941 19.1172 38.2603 18.7772 37.8386 18.5941C37.417 18.4109 36.9406 18.399 36.5103 18.5608C36.081 18.7357 35.6095 18.78 35.1551 18.6881C34.7007 18.5963 34.2835 18.3723 33.9557 18.0444C33.628 17.7165 33.4043 17.2992 33.3126 16.8447C33.221 16.3903 33.2655 15.9189 33.4406 15.4896C33.6023 15.0593 33.5904 14.583 33.4072 14.1614C33.224 13.7398 32.884 13.406 32.4591 13.2306C32.0342 13.0552 31.5578 13.052 31.1305 13.2217C30.7033 13.3914 30.3589 13.7206 30.1701 14.1397C29.9898 14.566 29.6879 14.9297 29.302 15.1855C28.9162 15.4412 28.4636 15.5776 28.0007 15.5776C27.5379 15.5776 27.0853 15.4412 26.6994 15.1855C26.3136 14.9297 26.0117 14.566 25.8314 14.1397C25.6426 13.7206 25.2981 13.3913 24.8708 13.2216C24.4436 13.052 23.9671 13.0552 23.5422 13.2306C23.1172 13.406 22.7772 13.7399 22.5941 14.1615C22.4109 14.5832 22.399 15.0595 22.5608 15.4898C22.7357 15.9192 22.78 16.3906 22.6881 16.8451C22.5963 17.2995 22.3724 17.7167 22.0444 18.0445C21.7165 18.3722 21.2992 18.5959 20.8447 18.6875C20.3903 18.7792 19.9189 18.7347 19.4896 18.5596L19.4893 18.5599Z"
                      fill="#FF5B5B"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_1_3737"
                      x="0"
                      y="0"
                      width="56"
                      height="56"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1_3737"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1_3737"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
            </MenuButton>
          }
          transition
          direction={"bottom"}
          align={"end"}
          position={"anchor"}
          viewScroll={"auto"}
          arrow={true}
          className=" shadow-lg "
        >
          {/* <MenuItem className="flex items-center p-3 gap-3 hover:bg-gray-100 transition-colors">
              <FaUser className="text-darkCyan" />
              <span className="text-gray-700 font-medium">Account Settings</span>
            </MenuItem>
            <MenuItem className="flex items-center p-3 gap-3 hover:bg-gray-100 transition-colors">
              <MdPrivacyTip className="text-darkCyan" />
              <span className="text-gray-700 font-medium">Privacy</span>
            </MenuItem> */}
          <MenuItem
            className="flex items-center p-3 gap-3 hover:bg-gray-100 transition-colors"
            onClick={openModal}
          >
            <RiLockPasswordLine className="text-darkCyan" />
            <span className="text-gray-700 font-medium">Change Password</span>
          </MenuItem>

          <MenuItem
            className="flex items-center p-3 gap-3 hover:bg-gray-100 transition-colors"
            onClick={handleLogOut}
          >
            <LuLogOut className="text-darkCyan" />
            <span className="text-gray-700 font-medium">Logout</span>
          </MenuItem>
        </Menu>
        {/* Custom Modal */}
        {showPasswordModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white w-full max-w-md p-6 rounded-lg shadow-lg">
              <div className="p-2 mx-auto bg-white rounded-2xl w-40 border-2 border-darkCyan ">
                <img src="/images/logo.png" className="w-full" alt="" />
              </div>
              <h2 className="text-xl mt-2 font-bold text-center mb-3">
                Change Password
              </h2>

              <form onSubmit={handleSubmit(onSubmit)}>
                {/* New Password */}
                <div className="mb-3">
                  <label className="block mb-1">New Password</label>
                  <input
                    type="text"
                    {...register("newPassword", {
                      required: "New password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters",
                      },
                    })}
                    className="w-full border border-gray-300 p-2 rounded"
                  />
                  {typeof errors.newPassword?.message === "string" && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.newPassword.message}
                    </p>
                  )}
                </div>

                {/* Confirm Password */}
                <div className="mb-4">
                  <label className="block mb-1">Confirm Password</label>
                  <input
                    type="text"
                    {...register("confirmPassword", {
                      required: "Confirm your password",
                      validate: (value) =>
                        value === newPassword || "Passwords do not match",
                    })}
                    className="w-full border border-gray-300 p-2 rounded"
                  />
                  {typeof errors.confirmPassword?.message === "string" && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.confirmPassword.message}
                    </p>
                  )}
                </div>

                {/* Buttons */}
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={closeModal}
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                  {/* <button
                    type="submit"
                    className="px-4 py-2 bg-darkCyan text-white rounded hover:bg-cyan-700"
                  >
                    Save
                  </button> */}
                  <CustomButton
                    // addclass="w-full"
                    type="submit"
                    btntext={"save"}
                    isLoading={isPending}
                  />
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(Header);
